
    // this file was auto generated by python script
    import X from './X';
    export default X;
    